import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [form, setForm] = useState({ nouveau_mot_de_passe: '', confirmer: '' });
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [chargement, setChargement] = useState(false);
  const [succes, setSucces] = useState(false);

  useEffect(() => {
    if (!token) setMessage({ type: 'erreur', texte: '❌ Lien invalide ou incomplet.' });
  }, [token]);

  const champ = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const soumettre = async (e) => {
    e.preventDefault();
    if (form.nouveau_mot_de_passe !== form.confirmer) {
      setMessage({ type: 'erreur', texte: '❌ Les mots de passe ne correspondent pas.' });
      return;
    }
    if (form.nouveau_mot_de_passe.length < 6) {
      setMessage({ type: 'erreur', texte: '❌ Le mot de passe doit contenir au moins 6 caractères.' });
      return;
    }
    setChargement(true);
    try {
      await api.post('/users/reset-par-token', {
        token,
        nouveau_mot_de_passe: form.nouveau_mot_de_passe,
      });
      setSucces(true);
      setMessage({ type: 'succes', texte: '✅ Mot de passe défini avec succès ! Vous pouvez maintenant vous connecter.' });
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || '❌ Lien invalide ou expiré. Contactez l\'administrateur.' });
    } finally { setChargement(false); }
  };

  const S = {
    page: { minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    card: { background: 'white', borderRadius: 12, padding: 40, width: 450, boxShadow: '0 4px 20px rgba(0,0,0,0.12)', borderTop: '6px solid #1a5c2a' },
    logo: { width: 180, display: 'block', margin: '0 auto 20px' },
    titre: { color: '#1a5c2a', fontSize: 22, fontWeight: 'bold', textAlign: 'center', marginBottom: 8 },
    sousTitre: { color: '#666', fontSize: 13, textAlign: 'center', marginBottom: 25 },
    label: { display: 'block', fontSize: 13, color: '#555', marginBottom: 5, fontWeight: '600' },
    input: { width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginBottom: 15, boxSizing: 'border-box' },
    btn: { background: '#1a5c2a', color: 'white', border: 'none', padding: '14px', borderRadius: 8, fontSize: 16, fontWeight: 'bold', cursor: 'pointer', width: '100%' },
    alerte: (t) => ({ padding: '12px', borderRadius: 8, marginBottom: 15, background: t === 'succes' ? '#d4edda' : '#f8d7da', color: t === 'succes' ? '#155724' : '#721c24', textAlign: 'center' }),
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <img src="/logo-sogas.png" alt="SOGAS" style={S.logo} />
        <div style={S.titre}>🔑 Définir votre mot de passe</div>
        <div style={S.sousTitre}>SOGAS — Société de Gestion des Abattoirs du Sénégal</div>

        {message.texte && <div style={S.alerte(message.type)}>{message.texte}</div>}

        {!succes && token ? (
          <form onSubmit={soumettre}>
            <div>
              <label style={S.label}>Nouveau mot de passe</label>
              <input style={S.input} type="password" name="nouveau_mot_de_passe" value={form.nouveau_mot_de_passe} onChange={champ} placeholder="Minimum 6 caractères" required />
            </div>
            <div>
              <label style={S.label}>Confirmer le mot de passe</label>
              <input style={S.input} type="password" name="confirmer" value={form.confirmer} onChange={champ} placeholder="Répétez le mot de passe" required />
            </div>
            <button type="submit" style={S.btn} disabled={chargement}>
              {chargement ? '⏳ Enregistrement...' : '✅ DÉFINIR MON MOT DE PASSE'}
            </button>
          </form>
        ) : succes ? (
          <button style={S.btn} onClick={() => navigate('/login')}>
            🔐 Se connecter maintenant
          </button>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#666', marginBottom: 20 }}>Contactez votre administrateur pour obtenir un nouveau lien.</p>
            <button style={S.btn} onClick={() => navigate('/login')}>← Retour à la connexion</button>
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#999' }}>
          © 2026 SOGAS — Développé par Abdoul Aziz Talla
        </div>
      </div>
    </div>
  );
}
